'use client'
import{jsx as d}from"react/jsx-runtime";var i=()=>d("div",{children:"TicketCard"});export{i as a};
